import type { ReactNode } from 'react';

type FieldProps = {
  label: string;
  children: ReactNode;
};

export function Field({ label, children }: FieldProps) {
  return (
    <div className='ee-field'>
      <label>{label}</label>
      {children}
    </div>
  );
}

type ColorRowProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export function ColorRow({ label, value, onChange, disabled }: ColorRowProps) {
  return (
    <div className='ee-colorrow'>
      <span>{label}</span>
      <label className='ee-swatch' style={{ background: value }}>
        <input type='color' value={value} onChange={(e) => onChange(e.target.value)} disabled={disabled} />
      </label>
      <input
        className='input ee-colorhex'
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
}

type SegOption = { v: string; label: string };

type SegGroupProps = {
  value: string;
  onChange: (v: string) => void;
  options: SegOption[];
  disabled?: boolean;
};

export function SegGroup({ value, onChange, options, disabled }: SegGroupProps) {
  return (
    <div className='ee-seggroup'>
      {options.map((o) => (
        <button key={o.v} type='button' className={value === o.v ? 'is-on' : ''} onClick={() => onChange(o.v)} disabled={disabled}>
          {o.label}
        </button>
      ))}
    </div>
  );
}

type QuadProps = {
  values: [number, number, number, number];
  grouped: boolean;
  onChange: (top: number, right: number, bottom: number, left: number) => void;
  disabled?: boolean;
};

export function Quad({ values, grouped, onChange, disabled }: QuadProps) {
  const [t, r, b, l] = values;

  if (grouped) {
    return (
      <div className='ee-quad-grouped'>
        <span>↕↔</span>
        <input
          className='input'
          type='number'
          value={t}
          disabled={disabled}
          onChange={(e) => {
            const v = +e.target.value;
            onChange(v, v, v, v);
          }}
        />
        <div className='ee-unit'>px</div>
      </div>
    );
  }

  return (
    <div className='ee-quad'>
      <div className='ee-quad__cell'>
        <span>↑</span>
        <input type='number' value={t} disabled={disabled} onChange={(e) => onChange(+e.target.value, r, b, l)} />
      </div>
      <div className='ee-quad__cell'>
        <span>→</span>
        <input type='number' value={r} disabled={disabled} onChange={(e) => onChange(t, +e.target.value, b, l)} />
      </div>
      <div className='ee-quad__cell'>
        <span>↓</span>
        <input type='number' value={b} disabled={disabled} onChange={(e) => onChange(t, r, +e.target.value, l)} />
      </div>
      <div className='ee-quad__cell'>
        <span>←</span>
        <input type='number' value={l} disabled={disabled} onChange={(e) => onChange(t, r, b, +e.target.value)} />
      </div>
    </div>
  );
}
